"use strict";

import { from, of, take } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
//  import { merge } from "rxjs";
import {
    mergeMap,
    catchError,
    map,
    concatMap,
    merge,
    takeUntil,
} from "rxjs/operators";

import {
    ajaxError,
    campaignGetLatestCampaignComplete,
    getHomeCarouselCampaignComplete,
    campaignHomeGetBestVoucherDealsTodayComplete,
    campaignHomeGetTrendingVouchersComplete,
    campaignGetFeaturedCampaignBannersComplete,
    campaignGetCampaignDetailsComplete,
    campaignTokenValidationComplete,
    campaignSpinwinGetDataComplete,
    campaignSpinwinGetInitialDataComplete,
    joingIncentiveDataComplete,
    campaignHomeBannersComplete,
    campaignVoucherAddToFavouriteComplete,
    campaignVoucherRemoveFromFavouriteComplete,
    refreshTokenAuthRequest,
    refreshTokenAuthComplete,
    getCampaignLeagueTableComplete,
    getParticipantSalesComplete,
    shopFavouritesRequest,
    campaignPrizeDrawDetailsComplete,
    addPrizeDrawCampaignEntryComplete,
    campaignGetCampaignDetailsRequest,
    campaignPrizeDrawDetailsRequest,
    getLeagueIndividualDetailsComplete,
    getLeagueTeamDetailsComplete,
    submitLeagueTeamParticipantComplete,
    getCommsDetailsComplete,
    campaignGetWareAndTireSummaryComplete,
    campaignGetLeagueTableSummaryComplete,
    campaignGetParticipantIncentiveComplete,
    campaignGetParticipantIncentiveCampaignPerformanceMetricsComplete,
    shopVoucherDetailsRequest,
    campaignGetCastrolLeagueTableSummaryComplete,
    campaignPageLogPageViewComplete,
    campaignLikeContentPageComplete,
    campaignLikeSummaryComplete,
    campaignLikeSummaryRequest,
    campaignGetAreaManagerDealersComplete,
    campaignGetAreaManagerDealersRequest,
    campaignGetParticipantsByDealerComplete,
    campaignGetPerformanceMetricsByDealerComplete,
    campaignGetAreaManagersLeaguesRankSummaryComplete,
    campaignGetCastrolLeagueQ4TableSummaryComplete,
    campaignGetServiceManagersLeaguesBonusRankBatterySummaryComplete,
    campaignGetServiceManagersLeaguesBonusRankBrakePadsSummaryComplete,
    campaignGetServiceManagersLeaguesBonusRankWiperBladeSummaryComplete,
    campaignGetServiceManagersLeaguesBonusRankBrakeDiscsSummaryComplete,
    campaignGetServiceManagersLeaguesBonusRankAreaTopPerformerSummaryComplete,
    campaignGetLeagueNationalTopPerformerSummaryComplete,
    getTlcCustomerComplete,
    getGoldRushCampaignPerformanceSummaryComplete,
    getCastrolDealerPerformanceSummaryComplete,
    campaignGetPerformanceMetricsByDealerDropDownComplete,
    campaignGetServiceManagersLeaguesBonusRankBatterySummaryDropDownComplete,
    campaignGetLeagueNationalTopPerformerSummaryDropDownComplete,
    campaignGetLeagueTableSummaryDropDownComplete,
    campaignGetTlcRetailersComplete,
    getTlcCustomerRequest,
    campaignGetWearAndTearTeamPerformanceSummaryComplete,
    campaignGetServiceStartLeagueRankSummaryComplete,
    campaignTokenValidationError,
    campaignGetWinningSpinDataComplete,
    campaignGetAlpineRewardSummaryComplete,
    campaignGetTradePartsManagerSalesSummaryComplete,
    campaignGetCastrolMotoLeaguesRankSummaryComplete,
    campaignGetTLCCustomerByDealersComplete,
    campaignGetFullThrottleLeagueRankSummaryComplete,
    campaignGoldenTicketScratchCardDataComplete,
    campaignGoldenTicketClaimScratchCardCodeComplete,
    campaignVoteRewardPreferencesComplete,
    getParticipantProfileRequest,
    campaignGetAllAreaManagerDealersComplete,
    campaignGetRewardAndRecognitionTeamMateComplete,
    campaignGetRewardAndRecognitionNominationReasonComplete,
    campaignPostRewardAndRecognitionNominationSendComplete,
    campaignGetRewardAndRecognitionGetParticipantPostsComplete,
    campaignGetRewardAndRecognitionGetAiParaphraseComplete,
    campaignPostRewardAndRecognitionRewardNominationCommentsComplete,
    campaignGetRewardAndRecognitionNominationReasonRequest,
    campaignPostRewardAndRecognitionLikeRewardPostComplete,
} from "../_actions";
import {
    campaignConstants,
    requestTypes,
    authConstants,
    commonConstants,
    addRemoveFavouriteContent,
    participantJobRoleIds,
} from "../_constants";
import { getRequestHeader } from "../../_helpers/request.header";

export const getLatestCampaignEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_LATEST_CAMPAIGN_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/latest-campaigns",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignGetLatestCampaignComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getHomeCarouselCampaignEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_HOME_CAROUSEL_CAMPAIGN_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/campaign/carousel-campaigns",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getHomeCarouselCampaignComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const getHomeGetBestVoucherDealsTodayEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_HOME_BEST_VOUCHER_DEALS_TODAY_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/shop/spend-on-experiences",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignHomeGetBestVoucherDealsTodayComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error, source) => {
                        if (error.response.statusCode == "401") {
                            return actions$.pipe(
                                ofType(
                                    authConstants.AUTH_GET_REFRESH_TOKEN_COMPLETE,
                                ),
                                take(1),
                                mergeMap((action) => source),
                                merge(of(refreshTokenAuthRequest())),
                                takeUntil(
                                    actions$.pipe(
                                        ofType(
                                            commonConstants.REFRESH_TOKEN_ERROR,
                                        ),
                                    ),
                                ),
                            );
                        } else {
                            return of(ajaxError(error));
                        }
                    }),
                ),
        ),
    );
};

export const getHomeGetTrendingVouchersEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_HOME_TRENDING_VOUCHER_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/campaign/campaign-vouchers",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignHomeGetTrendingVouchersComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const getFeaturedCampaignBannersEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_FEATURED_CAMPAIGN_BANNERS_REQUEST),
        mergeMap((action) =>
            ajax
                .get(
                    "/api/campaign/featured-banners",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignGetFeaturedCampaignBannersComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const getHomeGetCampaignDetailsEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_CAMPAIGN_DETAILS_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/campaign/campaign-details",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignGetCampaignDetailsComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const campaignTokenValidationEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_SPINWIN_TOKEN_VALIDATION_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/campaign/validate-spinwin-tokens",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignTokenValidationComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) =>
                        of(ajaxError(error)).pipe(
                            concatMap(() => of(campaignTokenValidationError())),
                        ),
                    ),
                ),
        ),
    );
};

export const campaignSpinwingetDataEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_SPINWIN_GET_DATA_REQUEST),
        mergeMap((action) => {
            const { setSuccessView, ...payload } = action.payload;

            return ajax
                .post(
                    "/api/campaign/get-hitandwin-spin-data",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        setSuccessView(ajaxResponse.response.data);
                        return campaignSpinwinGetDataComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignSpinwingetInitialDataEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_SPINWIN_GET_INITIAL_DATA_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/campaign/get-hitandwin-spin-initial-data",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignSpinwinGetInitialDataComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const joinIncentiveDataEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.JOING_INCENTIVE_DATA_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/campaign/join-incentive",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return joingIncentiveDataComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const getCampaignHomeBannersEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_HOME_BANNERS_REQUEST),
        mergeMap((action) => {
            return ajax
                .get(
                    "/api/campaign/home-banners",
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignHomeBannersComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getCampaignVoucherAddToFavouriteEpic = (
    actions$,
    state$,
    { dispatch },
) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_VOUCHER_ADDTO_FAVOURITE_REQUEST),
        mergeMap((action) => {
            const { from, ...payload } = action.payload;

            return ajax
                .post(
                    "/api/campaign/campaign-voucher-addto-favourite",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        if (
                            addRemoveFavouriteContent.FROM_PRODUCT_CONTENT ==
                            from
                        ) {
                            dispatch(
                                shopVoucherDetailsRequest({ id: payload.id }),
                            );
                        }

                        if (addRemoveFavouriteContent.FROM_WALLET == from) {
                        }

                        if (addRemoveFavouriteContent.FROM_HOME_PAGE == from) {
                            dispatch(
                                shopFavouritesRequest({
                                    pageNumber: 1,
                                    pageSize: 8,
                                    type: 0,
                                }),
                            );
                        }

                        return campaignVoucherAddToFavouriteComplete(
                            action.payload,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getCampaignVoucherRemoveFromFavouriteEpic = (
    actions$,
    state$,
    { dispatch },
) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_VOUCHER_REMOVEFROM_FAVOURITE_REQUEST),
        mergeMap((action) => {
            const { from, ...payload } = action.payload;

            return ajax
                .post(
                    "/api/campaign/campaign-voucher-removefrom-favourite",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        if (
                            addRemoveFavouriteContent.FROM_PRODUCT_CONTENT ==
                            from
                        ) {
                            dispatch(
                                shopVoucherDetailsRequest({ id: payload.id }),
                            );
                        }

                        if (addRemoveFavouriteContent.FROM_WALLET == from) {
                        }

                        if (addRemoveFavouriteContent.FROM_HOME_PAGE == from) {
                            dispatch(
                                shopFavouritesRequest({
                                    pageNumber: 1,
                                    pageSize: 8,
                                    type: 0,
                                }),
                            );
                        }

                        return campaignVoucherRemoveFromFavouriteComplete(
                            action.payload,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getCampaignLeagueTableEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_CAMPAIGN_LEAGUE_TABLE_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-league-table",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getCampaignLeagueTableComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getParticipantSalesEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_PARTICIPANT_SALES_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/user/get-participant-sales",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getParticipantSalesComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignPrizeDrawDetailsEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_CAMPAIGN_PRIZEDRAW_DETAILS_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-prizedraw-details",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignPrizeDrawDetailsComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const addPrizeDrawCampaignEntryDataEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.ADD_PRIZE_DRAW_CAMPAIGN_ENTRY_DATA_REQUEST),
        mergeMap((action) => {
            const { tokenForms, ...payload } = action.payload;

            return ajax
                .post(
                    "/api/campaign/add-prize-draw-campaign-entry",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        tokenForms.forEach((form) => {
                            form.reset();
                        });

                        return of(
                            campaignGetCampaignDetailsRequest({
                                id: action.payload.campaignId,
                            }),

                            campaignPrizeDrawDetailsRequest({
                                id: action.payload.campaignId,
                            }),

                            addPrizeDrawCampaignEntryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getLeagueIndividualDetailsEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_LEAGUE_INDIVIDUAL_DETAILS_DATA_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/league-individual-details",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getLeagueIndividualDetailsComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getLeagueTeamDetailsEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_LEAGUE_TEAM_DETAILS_DATA_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/league-team-details",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getLeagueTeamDetailsComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const submitLeagueTeamParticipantEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.SUBMIT_LEAGUE_TEAM_PARTICIPANT_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/submit-league-team-participant",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return submitLeagueTeamParticipantComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getCommsDetailsEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_COMMS_DETAILS_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/comms-details",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getCommsDetailsComplete(ajaxResponse.response);
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetWareAndTireSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_WARE_AND_TIRE_SUMMARY_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-ware-and-tire-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetWareAndTireSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetLeagueTableSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-league-table-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetLeagueTableSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetLeagueTableSummaryDropDownEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_DROP_DOWN_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-league-table-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetLeagueTableSummaryDropDownComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetParticipantIncentiveEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_PARTICIPANT_ACTIVE_CAMPAIGNS_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-participant-incentive",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetParticipantIncentiveComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetParticipantIncentiveCampaignPerformanceMetricsEpic = (
    actions$,
) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_PARTICIPANT_INCENTIVE_PERFORMANCE_METRICS_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-participant-incentive-campaign-performance-metrics",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetParticipantIncentiveCampaignPerformanceMetricsComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetCastrolLeagueTableSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-castrol-league-table-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetCastrolLeagueTableSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetCastrolLeagueQ4TableSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_Q4_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-castrol-league-q4-table-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetCastrolLeagueQ4TableSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignPageLogPageViewEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_PAGE_LOG_PAGE_VIEW_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-page-log-page-view",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignPageLogPageViewComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignLikeContentPageEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_PAGE_LIKE_CONTENT_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-page-like-content",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignLikeContentPageComplete(
                                ajaxResponse.response,
                            ),
                            campaignLikeSummaryRequest(action.payload),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignLikeSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_PAGE_LIKE_SUMMARY_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-page-summary-like-content",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignLikeSummaryComplete(ajaxResponse.response),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetAreaManagerDealersEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_AREA_MANAGERS_DEALERS_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-area-manager-dealers",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetAreaManagerDealersComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetParticipantsByDealerEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_PARTICIPANTS_BY_DEALERS_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-participants-by-dealer",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetParticipantsByDealerComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetPerformanceMetricsByDealerEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-performance-metrics-by-dealer",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetPerformanceMetricsByDealerComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetPerformanceMetricsByDealerDropDownEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_DROP_DOWN_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-performance-metrics-by-dealer",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetPerformanceMetricsByDealerDropDownComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetAreaManagersLeaguesRankSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_AREA_MANAGER_LEAGUES_RANK_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-area-managers-leagues-rank-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetAreaManagersLeaguesRankSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetServiceManagersLeaguesBonusBatteryRankSummaryEpic = (
    actions$,
) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-service-managers-leagues-battery-rank-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetServiceManagersLeaguesBonusRankBatterySummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetServiceManagersLeaguesBonusBatteryRankSummaryDropDownEpic =
    (actions$) => {
        return actions$.pipe(
            ofType(
                campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_DROP_DOWN_REQUEST,
            ),
            mergeMap((action) => {
                return ajax
                    .post(
                        "/api/campaign/campaign-get-service-managers-leagues-battery-rank-summary",
                        action.payload,
                        getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                        concatMap((ajaxResponse) => {
                            return of(
                                campaignGetServiceManagersLeaguesBonusRankBatterySummaryDropDownComplete(
                                    ajaxResponse.response,
                                ),
                            );
                        }),
                        catchError((error) => of(ajaxError(error))),
                    );
            }),
        );
    };

export const campaignGetServiceManagersLeaguesBonusBrakePadsRankSummaryEpic = (
    actions$,
) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_PADS_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-service-managers-leagues-bonus-rank-brake-pads-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetServiceManagersLeaguesBonusRankBrakePadsSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetServiceManagersLeaguesBonusRankWiperBladeSummaryEpic = (
    actions$,
) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_WIPER_BLADE_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-service-managers-leagues-bonus-rank-wiper-blade-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetServiceManagersLeaguesBonusRankWiperBladeSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetServiceManagersLeaguesBonusRankBrakeDiscsSummaryEpic = (
    actions$,
) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_DISCS_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-service-managers-leagues-bonus-rank-brake-discs-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetServiceManagersLeaguesBonusRankBrakeDiscsSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetServiceManagersLeaguesBonusRankAreaTopPerformerSummaryEpic =
    (actions$) => {
        return actions$.pipe(
            ofType(
                campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_AREA_TOP_SUMMARY_REQUEST,
            ),
            mergeMap((action) => {
                return ajax
                    .post(
                        "/api/campaign/campaign-get-service-managers-leagues-bonus-rank-area-top-summary",
                        action.payload,
                        getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                        concatMap((ajaxResponse) => {
                            return of(
                                campaignGetServiceManagersLeaguesBonusRankAreaTopPerformerSummaryComplete(
                                    ajaxResponse.response,
                                ),
                            );
                        }),
                        catchError((error) => of(ajaxError(error))),
                    );
            }),
        );
    };

export const campaignGetLeagueNationalTopPerformerSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-league-national-top-performer-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetLeagueNationalTopPerformerSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetLeagueNationalTopPerformerSummaryDropDownEpic = (
    actions$,
) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_DROP_DOWN_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-league-national-top-performer-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetLeagueNationalTopPerformerSummaryDropDownComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getTlcCustomerEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_TLC_CUSTOMER_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/campaign/get-tlc-customers",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getTlcCustomerComplete(ajaxResponse.response);
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const getGoldRushCampaignPerformanceSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.GET_GOLD_RUSH_CAMPAIGN_PERFORMANCE_SUMMARY_REQUEST,
        ),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/campaign/get-gold-rush-campaign-performance-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getGoldRushCampaignPerformanceSummaryComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const getCastrolDealerPerformanceSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.GET_CASTROL_DEALER_PERFORMANCE_SUMMARY_REQUEST,
        ),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/campaign/get-castrol-dealer-performance-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getCastrolDealerPerformanceSummaryComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const campaignGetTlcRetailersEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.TLC_GET_TLC_RETAILERS_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/get-tlc-retailer",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        if (
                            action?.payload ===
                            participantJobRoleIds.TLC_PARTICIPANT_AREA_MANAGER
                        ) {
                            return of(
                                getTlcCustomerRequest({
                                    reatilerId:
                                        ajaxResponse.response.data[0]?.id,
                                    reatilerName:
                                        ajaxResponse.response.data[0]?.name,
                                }),
                                campaignGetTlcRetailersComplete(
                                    ajaxResponse.response,
                                ),
                            );
                        } else {
                            return of(
                                campaignGetTlcRetailersComplete(
                                    ajaxResponse.response,
                                ),
                            );
                        }
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetWearAndTearTeamPerformanceSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_WEAR_AND_TEAR_TEAM_PERFORMANCE_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetWearAndTearTeamPerformanceSummary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetWearAndTearTeamPerformanceSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetServiceStartLeagueRankSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_SERVICE_STAR_GET_SERVICE_STAR_LEAGUE_RANK_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetServiceStartLeagueRankSummary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetServiceStartLeagueRankSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetWinningSpinDataEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_WINNING_SPIN_DATA_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetWinningSpinsData",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetWinningSpinDataComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetAlpineRewardSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_ALPINE_REWARD_SUMMARY_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetAlpineRewardSummary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetAlpineRewardSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetTradePartsManagerSalesSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_TRADE_PARTS_MANAGER_INCENTIVE_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetTradePartsManagerSalesSummary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetTradePartsManagerSalesSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetCastrolMotoLeaguesRankSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_CASTROL_MOTO_GP_LEAGUES_RANK_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetCastrolMotoLeaguesRankSummary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetCastrolMotoLeaguesRankSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetTLCCustomerByDealersEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_TLC_CUSTOMER_BY_DEALERS_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/getTLCCustomerByDealers",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetTLCCustomerByDealersComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetFullThrottleLeagueRankSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_FULL_THROTTLE_LEAGUE_RANK_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/getFullThrottleLeagueRankSummary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetFullThrottleLeagueRankSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGoldenTicketScratchCardDataEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GOLDEN_TICKET_SCRATCH_CARD_DATA_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/goldenTicketScratchCardData",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGoldenTicketScratchCardDataComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGoldenTicketClaimScratchCardCodeEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GOLDEN_TICKET_CLAIM_SCRATCH_CARD_CODE_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/claimScratchCardCode",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGoldenTicketClaimScratchCardCodeComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignVoteRewardPreferencesEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_VOTE_REWARD_PREFERENCES_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/VoteRewardPreferences",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            getParticipantProfileRequest({}),
                            campaignVoteRewardPreferencesComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};
export const campaignGetAllAreaManagerDealersEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_ALL_AREA_MANAGERS_DEALERS_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-area-manager-dealers",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetAllAreaManagerDealersComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetRewardAndRecognitionTeamMateEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_REWARD_AND_RECOGNITION_TEAM_MATE_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetTeamMembers",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetRewardAndRecognitionTeamMateComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetRewardAndRecognitionNominationReasonEpic = (
    actions$,
) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_REWARD_AND_RECOGNITION_NOMINATION_REASON_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetTeamRewardReasons",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetRewardAndRecognitionNominationReasonComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignPostRewardAndRecognitionNominationSendEpic = (
    actions$,
) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_POST_REWARD_AND_RECOGNITION_NOMINATION_SEND_REQUEST,
        ),
        mergeMap((action) => {
            const { form, resetFormsData, ...payload } = action.payload;

            const fullPayload = {
                id: action?.payload?.id,
                nominatedBy: action?.payload?.id,
                nominatedFor: action?.payload?.nominatedFor,
                rewardReasonId: action?.payload?.rewardReasonId,
                postText: action?.payload?.postText,
                imageUrl: action?.payload?.imageUrl,
            };
            return ajax
                .post(
                    "/api/campaign/PostRewardNomination",
                    fullPayload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        resetFormsData();
                        form.reset();
                        return of(
                            campaignGetRewardAndRecognitionNominationReasonRequest(),
                            campaignPostRewardAndRecognitionNominationSendComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetRewardAndRecognitionGetParticipantPostsEpic = (
    actions$,
) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_REWARD_AND_RECOGNITION_NOMINATION_REASON_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetParticipantPosts",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetRewardAndRecognitionGetParticipantPostsComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetRewardAndRecognitionGetAiParaphraseEpic = (
    actions$,
) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_AI_PARAPHRASE_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetAiParaphrase",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        const raw = ajaxResponse.response.data;
                        const cleaned = raw.map((item) => {
                            try {
                                return JSON.parse(item);
                            } catch {
                                return item.replace(/^"|"$/g, "");
                            }
                        });
                        const formatted = cleaned.map((text, idx) => ({
                            id: idx,
                            text,
                        }));
                        return of(
                            campaignGetRewardAndRecognitionGetAiParaphraseComplete(
                                formatted,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignPostRewardAndRecognitionRewardNominationCommentsEpic = (
    actions$,
) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_POST_REWARD_AND_RECOGNITION_REWARD_NOMINATION_COMMENTS_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/RewardNominationComments",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetRewardAndRecognitionNominationReasonRequest(),
                            campaignPostRewardAndRecognitionRewardNominationCommentsComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignPostRewardAndRecognitionLikeRewardPostEpic = (
    actions$,
) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_POST_REWARD_AND_RECOGNITION_REWARD_LIKE_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/LikeRewardPost",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetRewardAndRecognitionNominationReasonRequest(),
                            campaignPostRewardAndRecognitionLikeRewardPostComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};
